import Vue from 'vue'
import App from './App.vue'
import store from './store'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCog, faPlay, faBolt, faRotateLeft, faCheck, faXmark, faSquareMinus } from '@fortawesome/free-solid-svg-icons'
import { faFileCirclePlus, faShuffle, faCopy, faSquarePlus, faTableList, faFloppyDisk } from '@fortawesome/free-solid-svg-icons'
import { faMagnifyingGlass, faClockRotateLeft, faEye, faEquals, faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { faCircleQuestion } from '@fortawesome/free-regular-svg-icons'
import vueShortkey from 'vue-shortkey'
import router from './router'
import ToastPlugin from 'vue-toast-notification';
// Import one of the available themes
// import 'vue-toast-notification/dist/theme-default.css';
import 'vue-toast-notification/dist/theme-bootstrap.css';


Vue.config.productionTip = false

library.add(faCog, faFileCirclePlus, faPlay, faBolt, faRotateLeft, faMagnifyingGlass, faChevronUp, faChevronDown,
  faTableList, faCheck, faXmark, faShuffle, faCopy, faFloppyDisk, faSquareMinus, faEquals, faSquarePlus, faCircleQuestion, faClockRotateLeft, faEye)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(vueShortkey, { prevent: ['input', 'textarea'] })
Vue.use(ToastPlugin)

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
